
import React from 'react';
import { useProjectDocumentTitle } from '../utils/document';

const UserAgreement = () => {
    useProjectDocumentTitle("Terms of Use");
    return (
        <div className="p-8 bg-white text-gray-900">
            <html><head></head><body>

                <div></div>

                <span><br></br>
                </span>

                <div>

                    <p className="text-base mb-2"><span>PLEASE
                        READ THESE TERMS CAREFULLY BEFORE USING THIS SITE  </span></p>

                    <p className="text-base mb-2"><span>These
                        terms tell you (“<b>You</b>”, “<b>Customer</b>”) the rules for using our
                        website </span><span><a className="text-blue-600 underline"><span>www.briterbridges.com</span></a></span><span> (<b>“Site”</b>).</span></p>

                    <p className="text-base mb-2"><span> </span></p>

                    <p className="text-base mb-2"><b><span>Who are we? </span></b></p>

                    <p className="text-base mb-2"><span><a className="text-blue-600 underline">www.briterbridges.com</a> </span><span>is a site operated by </span><span><span>Briter</span></span><span> Bridges Ltd</span><span> <span>(”<b>We</b></span>”, “<b>Supplier</b>”). We are registered in England and Wales under company
                        number </span><strong><span>11653314</span></strong><strong><span> </span></strong><span>and have our registered office at
                        </span><span>Castle House, Castle Street, Guildford, Surrey, England, GU1 3UW</span><span>. Our VAT number is <b>11653314</b>.
                        </span><b><span>

                        </span></b></p>

                    <p className="text-base mb-2"><span>To
                        contact us, please email </span><span><a className="text-blue-600 underline"><span>feedback@briterbridges.com</span></a></span><span>. </span><span>

                        </span></p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><span>By using
                        our Site, you confirm that you accept these terms of use and that you agree to
                        comply with them. If you do not agree to these terms, you must not use our
                        Site. We recommend that you print a copy of these terms for future reference.</span></p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><span>These
                        terms of use refer to the following additional terms, which also apply to your
                        use of our Site:</span></p>

                    <p className="text-base mb-2">
                        <span><span>•<span>       </span></span></span>
                        <span>

                        </span><span>Our Acceptable Use Policy </span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>•<span>       </span></span></span>
                        <span>

                        </span><span>Our Privacy Policy </span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>•<span>       </span></span></span>
                        <span>Our Cookie Policy, which sets out
                            information about the cookies on our Site</span>
                    </p>

                    <p className="text-base mb-2"><span>If you
                        sign up to our free account or you purchase services from our Site</span><span>

                        </span><span>, the terms of the User Agreement
                            will also apply.</span></p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                </div>

                <span><br></br>
                </span>

                <div>

                    <div>

                        <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>USER
                            AGREEMENT (“</span></b><span>

                            </span><b><span>Agreement”) </span></b></p>

                    </div>

                    <p className="text-base mb-2"><span>

                    </span><span>This User Agreement creates
                        "software as a service" (SaaS) arrangement, providing
                        for the secure delivery of services to the user's terminal on a subscription
                        basis over a network from processors hosted remotely by the SaaS provider.</span><span>

                        </span></p>

                    <p className="text-base mb-2"><span>The Supplier has agreed to
                        provide and the Customer has agreed to take, and pay if applicable, for the
                        Supplier's service subject to the terms and conditions of this Agreement.</span></p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <table>
                    </table>

                    <p className="text-base mb-2"><b><span>

                    </span></b></p>

                    <p className="text-base mb-2"><b><span>

                    </span></b></p>

                    <p className="text-base mb-2"><b><span>Agreed terms</span></b></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>1.<span>
                        </span></span></span></b>
                        <b><span>Interpretation</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>1.1<span>
                        </span></span></span>
                        <span>The definitions and rules of interpretation in this clause
                            apply in this Agreement.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>Authorised Users</span></b><span>: those employees, agents and
                        independent contractors of the Customer who are authorised by the Customer to
                        use the Services, as further described in clause 2.2.<b>

                        </b></span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>Business Day</span></b><span>: a day other than a Saturday,
                        Sunday</span><span>

                        </span><span><span> </span>are open for </span><span>


                        </span><b><span>

                        </span></b></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>Confidential Information</span></b><span>: information that is proprietary
                        or confidential and is either clearly labelled as such or identified as
                        Confidential Information in clause 11.5 or clause 11.6.<b>

                        </b></span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>Customer Data</span></b><span>: the data inputted by the
                        Customer, Authorised Users, or the Supplier on the Customer's behalf for the
                        purpose of using the Services or facilitating the Customer's use of the
                        Services. <b>

                        </b></span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>Effective Date</span></b><span>: the date of this Agreement.<b>

                    </b></span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>Initial Subscription Term</span></b><span>: the initial term of this
                        Agreement as set out in the </span><span>


                        </span><span>Order.<b>

                        </b></span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>Order: </span></b><span>the
                        plan selected by the Customer at the time of making the payment.</span></p>

                    <p className="text-base mb-2"><b><span>Renewal Period</span></b><span>: the period described in clause 14.1.<b>

                    </b></span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>Services</span></b><span>: the subscription services
                        provided by the Supplier to the Customer under this Agreement via </span><span><a className="text-blue-600 underline">https://intelligence.briterbridges.com</a>,
                            <a className="text-blue-600 underline">https://agbase.briterbridges.com</a>,
                            <a className="text-blue-600 underline">https://intelligence.agbase.briterbridges.com</a>
                            <span>or any other website notified to the Customer by the
                                Supplier from time to time.<b>

                                </b></span></span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>Software</span></b><span>: the online software
                        applications provided by the Supplier as part of the Services.<b>

                        </b></span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>Subscription Fees</span></b><span>: the subscription fees payable
                        by the Customer to the Supplier for the User Subscriptions, as set out in the
                        Order and on the Supplier’s Site.<b>

                        </b></span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>Subscription Term</span></b><span>: has the meaning given in clause
                        14.1 (being the Initial Subscription Term together with any subsequent Renewal
                        Periods).<b>

                        </b></span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"><b><span>User Subscriptions</span></b></a><span><span>: the user subscriptions purchased by the Customer pursuant
                        to clause 9.1 which entitle Authorised Users to access and use the Services in
                        accordance with this Agreement.</span></span><span><span>
                            <a className="text-blue-600 underline">[AJ1]</a>
                            <span> </span>
                        </span></span><b><span>

                        </span></b></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><b><span>Virus</span></b><span>: <span>any thing</span>
                        or device (including any software, code, file or programme) which may: prevent,
                        impair or otherwise adversely affect the operation of any computer software,
                        hardware or network, any telecommunications service, equipment or network or
                        any other service or device; prevent, impair or otherwise adversely affect
                        access to or the operation of any programme or data, including the reliability
                        of any programme or data (whether by </span><span>

                        </span><span>, altering or erasing the
                            programme or data in whole or part or otherwise); or adversely affect the user
                            experience, including worms, trojan horses, viruses and other similar things or
                            devices.</span></p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>2.<span>
                        </span></span></span></b>
                        <b><span>User subscriptions</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>2.1<span>
                        </span></span></span>
                        <span>Subject to the Customer purchasing the User Subscriptions in
                            accordance with this Agreement, the Supplier hereby grants to the Customer a
                            non-exclusive, non-transferable right, without the right to grant sublicences,
                            to permit the Authorised Users to use the Services during the Subscription Term
                            solely for the Customer's internal business operations.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>2.2<span>
                        </span></span></span>
                        <span>In relation to the Authorised Users, the Customer undertakes
                            that:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>the maximum number of Authorised Users that it authorises to
                            access and use the Services shall not exceed the number of User Subscriptions
                            it has purchased from time to time;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>it will not allow or suffer any
                            User Subscription to be used by more than one individual Authorised User;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(c)<span>
                        </span></span></span>
                        <span>each Authorised User shall keep a secure password for their
                            use of the Services and shall keep their password confidential;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(d)<span>       </span></span></span>
                        <span>it shall maintain a written, up
                            to date list of current Authorised Users and provide such list to the Supplier
                            within 5 Business Days of the Supplier's written request at any time or times;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(e)<span>
                        </span></span></span>
                        <span>it shall permit the Supplier or the Supplier's designated
                            auditor to audit the Services in order to establish the name and password of
                            each Authorised User and the Customer's data processing facilities to audit
                            compliance with this Agreement. Each such audit may be conducted no more than
                            once per quarter, at the Supplier's expense, and this right shall be exercised
                            with reasonable prior notice, in such a manner as not to substantially
                            interfere with the Customer's normal conduct of business;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(f)<span>
                        </span></span></span>
                        <span>if any of the audits referred to in clause 2.2(e) reveal
                            that any password has been provided to any individual who is not an Authorised
                            User, then without prejudice to the Supplier's other rights, the Customer shall
                            promptly disable such passwords and the Supplier shall not issue any new
                            passwords to any such individual; and</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(g)<span>
                        </span></span></span>
                        <span>if any of the audits referred to in clause 2.2(e) reveal
                            that the Customer has underpaid Subscription Fees to the Supplier, then without
                            prejudice to the Supplier's other rights, the Customer shall pay to the
                            Supplier an amount equal to such underpayment.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>2.3<span>
                        </span></span></span>
                        <span>The Customer shall not access, store, distribute or transmit
                            any Viruses, or any material during the course of its use of the Services that:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>is unlawful, harmful, threatening, defamatory, obscene,
                            infringing, harassing or racially or ethnically offensive;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>facilitates illegal activity;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(c)<span>
                        </span></span></span>
                        <span>depicts sexually explicit images;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(d)<span>       </span></span></span>
                        <span>promotes unlawful violence;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(e)<span>
                        </span></span></span>
                        <span>is discriminatory based on race, gender, colour, religious
                            belief, sexual orientation, disability; or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(f)<span>
                        </span></span></span>
                        <span>is otherwise illegal or causes damage or injury to any
                            person or property;</span>
                    </p>

                    <p className="text-base mb-2"><span>and the Supplier reserves the
                        right, without liability or prejudice to its other rights to the Customer, to
                        disable the Customer's access to any material that breaches the provisions of
                        this clause.</span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>2.4<span>
                        </span></span></span>
                        <span>The Customer shall not:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>except as may be allowed by any applicable law which is
                            incapable of exclusion by agreement between the parties and except to the
                            extent expressly permitted under this Agreement:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(i)<span>
                        </span></span></span>
                        <span>attempt to copy, modify, duplicate, create derivative works
                            from, frame, mirror, republish, download, display, transmit, or distribute all
                            or any portion of the Software in any form or media or by any means; or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(ii)<span>
                        </span></span></span>
                        <span>attempt to de-compile, reverse compile, disassemble, reverse
                            engineer or otherwise reduce to human-perceivable form all or any part of the
                            Software; or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>access all or any part of the
                            Services in order to build a product or service which competes with the
                            Services; or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(c)<span>
                        </span></span></span>
                        <span>use the Services to provide services to third parties; or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(d)<span>       </span></span></span>
                        <span>subject to clause 22.1, license,
                            sell, rent, lease, transfer, assign, distribute, display, disclose, or
                            otherwise commercially exploit, or otherwise make the Services available to any
                            third party except the Authorised Users, or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(e)<span>
                        </span></span></span>
                        <span>attempt to obtain, or assist third parties in obtaining,
                            access to the Services, other than as provided under this clause; or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(f)<span>
                        </span></span></span>
                        <span>introduce or permit the introduction of, any Virus into the
                            Supplier's network and information systems. </span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>2.5<span>
                        </span></span></span>
                        <span>The Customer shall use all reasonable endeavours to prevent
                            any unauthorised access to, or use of, the Services and, in the event of any
                            such unauthorised access or use, promptly notify the Supplier.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>2.6<span>
                        </span></span></span>
                        <span>The rights provided under this clause 2 are granted to the
                            Customer only, and shall not be considered granted to any subsidiary or holding
                            company of the Customer.</span>
                    </p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>3.<span>
                        </span></span></span></b>
                        <span>


                        </span><b><span>Additional user subscriptions</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><span>If the Customer wishes to purchase additional User
                        Subscriptions, the Customer shall </span><span>

                        </span><span>. </span></p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>4.<span>
                        </span></span></span></b>
                        <b><span>Services</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>4.1<span>
                        </span></span></span>
                        <span>The Supplier shall, during the
                            Subscription Term, provide the Services to the Customer on and subject to the
                            terms of this Agreement.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline">
                        <span><span>4.2<span>
                        </span></span></span>
                        <strong><span>The Customer acknowledges</span></strong>
                    </a><span><span> that a fundamental component of the Software is the
                        use of machine learning for the purpose of improving and providing its products
                        and services. Notwithstanding anything to the contrary, the Customer agrees
                        that the Supplier is hereby granted an indefinite right to use the Customer
                        Data to train its algorithms through machine learning techniques for such
                        purpose.</span></span><span><span>
                            <a className="text-blue-600 underline">[AJ2]</a>
                            <span> </span>
                        </span></span><span>

                        </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>4.3<span>
                        </span></span></span>
                        <span>

                        </span><span>The Supplier
                            shall use commercially reasonable endeavours to make the Services available 24
                            hours a day, seven days a week, except for:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>planned maintenance, or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>unscheduled
                            maintenance</span><span>

                        </span><a className="text-blue-600 underline"></a><span>

                        </span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a><b><span>

                    </span></b></p>

                    <p className="text-base mb-2">
                        <b><span><span>5.<span>
                        </span></span></span></b>
                        <b><span>Data
                            protection</span></b>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>5.1<span>
                        </span></span></span>
                        <span>The Supplier will process the
                            Customer’s personal data in line with its Privacy Policy available at:
                            https://intelligence.briterbridges.com/privacy-policy</span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>5.2<span>
                        </span></span></span>
                        <span>Both Parties agree to adhere to their
                            respective </span><span>obligations
                                under the Data Protection Act 2018.</span>
                    </p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>6.<span>
                        </span></span></span></b>
                        <b><span>Third party providers</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><span>The Customer acknowledges that the Services may enable or
                        assist it to access the website content of, correspond with, and purchase
                        products and services from, third parties via third-party websites and that it
                        does so solely at its own risk. The Supplier makes no representation, warranty
                        or commitment and shall have no liability or obligation whatsoever in relation
                        to the content or use of, or correspondence with, any such third-party website,
                        or any transactions completed, and any contract entered into by the Customer,
                        with any such third party. Any contract entered into and any transaction
                        completed via any third-party website is between the Customer and the relevant
                        third party, and not the Supplier. The Supplier recommends that the Customer
                        refers to the third party's website terms and conditions and privacy policy
                        prior to using the relevant third-party website. The Supplier does not endorse
                        or approve any third-party website nor the content of any of the third-party
                        website made available via the Services.</span></p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>7.<span>
                        </span></span></span></b>
                        <b><span>Supplier's obligations</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>7.1<span>
                        </span></span></span>
                        <span>The Supplier undertakes that the Services will be performed substantially
                            in accordance with this Agreement, the information contained on the Site and
                            with reasonable skill and care.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>7.2<span>
                        </span></span></span>
                        <span>The undertaking at clause 7.1 shall not apply to the extent
                            of any non-conformance which is caused by use of the Services contrary to the
                            Supplier's instructions, or modification or alteration of the Services by any
                            party other than the Supplier or the Supplier's duly authorised contractors or
                            agents. If the Services do not conform with the foregoing undertaking, Supplier
                            will, at its expense, use all reasonable commercial endeavours to correct any
                            such non-conformance promptly, or provide the Customer with an alternative
                            means of accomplishing the desired performance. Such correction or substitution
                            constitutes the Customer's sole and exclusive remedy for any breach of the
                            undertaking set out in clause 7.1.<span>  </span>

                        </span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>7.3<span>
                        </span></span></span>
                        <span>The Supplier:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>does not warrant that:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(i)<span>
                        </span></span></span>
                        <span>the Customer's use of the Services will be uninterrupted or
                            error-free; or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(ii)<span>
                        </span></span></span>
                        <span>that the Services, and/or the information obtained by the
                            Customer through the Services will meet the Customer's requirements; or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(iii)<span>      </span></span></span>
                        <span>the Software or the Services will
                            be free from vulnerabilities or Viruses.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>is not responsible for any
                            delays, delivery failures, or any other loss or damage resulting from the
                            transfer of data over communications networks and facilities, including the
                            internet, and the Customer acknowledges that the Services may be subject to limitations,
                            delays and other problems inherent in the use of such communications
                            facilities.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <span><span>7.4<span>
                        </span></span></span>
                        <span>The Supplier warrants that it has and will maintain all
                            necessary licences, consents, and permissions necessary for the performance of
                            its obligations under this Agreement.</span>
                    </p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>8.<span>
                        </span></span></span></b>
                        <b><span>Customer's obligations</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>8.1<span>
                        </span></span></span>
                        <span>The Customer shall:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>provide the Supplier with:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(i)<span>
                        </span></span></span>
                        <span>all necessary co-operation in relation to this Agreement;
                            and</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(ii)<span>
                        </span></span></span>
                        <span>all necessary access to such information as may be required
                            by the Supplier;</span>
                    </p>

                    <p className="text-base mb-2"><span>in order to provide the Services,
                        including but not limited to Customer Data, security access information and
                        configuration services;</span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>without affecting its other
                            obligations under this Agreement, comply with all applicable laws and
                            regulations with respect to its activities under this Agreement;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(c)<span>
                        </span></span></span>
                        <span>carry out all other Customer responsibilities set out in
                            this Agreement in a timely and efficient manner. In the event of any delays in
                            the Customer's provision of such assistance as agreed by the parties, the
                            Supplier may adjust any agreed timetable or delivery schedule as reasonably
                            necessary;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(d)<span>       </span></span></span>
                        <span>ensure that the Authorised Users
                            use the Services in accordance with the terms and conditions of this Agreement
                            and shall be responsible for any Authorised User's breach of this Agreement;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(e)<span>
                        </span></span></span>
                        <span>obtain and shall maintain all necessary licences, consents,
                            and permissions necessary for the Supplier, its contractors and agents to
                            perform their obligations under this Agreement, including without limitation
                            the Services;</span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>(f)<span>
                        </span></span></span>
                        <span>ensure that the Customer does not have multiple accounts in
                            place;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(g)<span>
                        </span></span></span>
                        <span>ensure that its network and systems comply with the relevant
                            specifications provided by the Supplier from time to time; and</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(h)<span>       </span></span></span>
                        <span>be, to the extent permitted by
                            law and except as otherwise expressly provided in this Agreement, solely
                            responsible for procuring, maintaining and securing its network connections and
                            telecommunications links from its systems to the Supplier's data centres, and
                            all problems, conditions, delays, delivery failures and all other loss or
                            damage arising from or relating to the Customer's network connections or
                            telecommunications links or caused by the internet.</span>
                    </p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>9.<span>
                        </span></span></span></b>
                        <b><span>Charges and payment</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>9.1<span>
                        </span></span></span>
                        <span>

                        </span><span>The Customer shall pay the
                            Subscription Fees to the Supplier for the User Subscriptions in accordance with
                            the plan selected in the Order.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>9.2<span>
                        </span></span></span>
                        <span>


                        </span><span>The Customer shall on the Effective Date provide to the
                            Supplier valid, up-to-date and complete credit card details or approved
                            purchase order information acceptable to the Supplier and any other relevant
                            valid, up-to-date and complete contact and billing details and, if the Customer
                            provides<a className="text-blue-600 underline"></a> its credit card details to the
                            Supplier, the Customer hereby authorises the Supplier to bill such credit card:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(i)<span>
                        </span></span></span>
                        <span>on the Effective Date for the Subscription Fees payable in
                            respect of the Initial Subscription Term; and</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(ii)<span>
                        </span></span></span>
                        <span>subject to clause 14.1, on each anniversary of the Effective
                            Date for the Subscription Fees payable in respect of the next Renewal Period;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <span><span>9.3<span>
                        </span></span></span>
                        <span>If the Supplier has not received payment within 7 days after
                            the due date, and without prejudice to any other rights and remedies of the
                            Supplier<a className="text-blue-600 underline"></a>, the Supplier may, without liability
                            to the Customer, disable the Customer's password, account and access to all or
                            part of the Services and the Supplier shall be under no obligation to provide
                            any or all of the Services while the invoice(s) concerned remain unpaid.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <span><span>9.4<span>
                        </span></span></span>
                        <span>All amounts and fees stated or referred to in this
                            Agreement:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>shall be payable in pounds sterling;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>are, subject to clause 13.3(b),
                            non-cancellable and non-refundable;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(c)<span>
                        </span></span></span>
                        <span>are exclusive of value added tax, which shall be added to
                            the Supplier's invoice(s) at the appropriate rate.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>9.5<span>
                        </span></span></span>
                        <span>The Supplier shall be entitled to increase the Subscription
                            Fees at the start of each Renewal Period.</span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>9.6<span>
                        </span></span></span>
                        <span>Optional services are
                            available on the Services (any such services, an "<b>Upgrade</b>"). By selecting an Upgrade, you agree to pay the
                            Supplier the monthly or annual subscription fees indicated for that service in
                            accordance with the Site. Payments will be charged on a pre-pay basis on the
                            day you sign up for an Upgrade and will cover the use of that service for a
                            monthly or annual subscription period as indicated. Upgrade fees are not
                            refundable.</span><span>

                        </span>
                    </p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>10.<span>
                        </span></span></span></b>
                        <b><span>Proprietary rights</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>10.1<span>
                        </span></span></span>
                        <span>The Customer acknowledges and agrees that the Supplier
                            and/or its licensors own all intellectual property rights in the Services.
                            Except as expressly stated herein, this Agreement does not grant the Customer
                            any rights to, under or in, any patents, copyright, database right, trade
                            secrets, trade names, trademarks (whether registered or unregistered), or any
                            other rights or licences in respect of the Services.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>10.2<span>
                        </span></span></span>
                        <span>The Supplier confirms that it has all </span><span>the rights
                            in relation to the Services that are necessary to grant all the rights it
                            purports to grant under, and in accordance with, the terms of this Agreement.</span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>10.3<span>
                        </span></span></span>
                        <span>The Customer
                            hereby grants to the Supplier a non-exclusive licence to copy, reproduce,
                            store, distribute, publish, export, adapt, edit and translate the Customer Data
                            to the extent reasonably required for the performance of the Provider's
                            obligations and the exercise of the Provider's rights under the Agreement. The
                            Customer also grants to the Provider the right to sub-license these rights to
                            its hosting, connectivity and telecommunications service providers, subject to
                            any express restrictions elsewhere in the Agreement.</span><span>

                        </span>
                    </p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>11.<span>
                        </span></span></span></b>
                        <b><span>Confidentiality
                            and compliance with policies</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>11.1<span>
                        </span></span></span>
                        <span>Each party may be given access to
                            Confidential Information from the other party in order to perform its
                            obligations under this Agreement. A party's Confidential Information shall not
                            be deemed to include information that:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>is or becomes publicly known other than through any act or
                            omission of the receiving party;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>was in the other party's lawful
                            possession before the disclosure;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(c)<span>
                        </span></span></span>
                        <span>is lawfully disclosed to the receiving party by a third
                            party without restriction on disclosure; or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(d)<span>       </span></span></span>
                        <span>is independently developed by the
                            receiving party, which independent development can be shown by written
                            evidence.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>11.2<span>
                        </span></span></span>
                        <span>Subject to clause 11.4, each party shall hold the other's
                            Confidential Information in confidence and not make the other's Confidential
                            Information available to any third party, or use the other's Confidential
                            Information for any purpose other than the implementation of this Agreement.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>11.3<span>
                        </span></span></span>
                        <span>Each party shall take all reasonable steps to ensure that
                            the other's Confidential Information to which it has access is not disclosed or
                            distributed by its employees or agents in violation of the terms of this
                            Agreement.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>11.4<span>
                        </span></span></span>
                        <span>A party may disclose Confidential Information to the extent
                            such Confidential Information is required to be disclosed by law, by any
                            governmental or other regulatory authority or by a court or other authority of
                            competent jurisdiction, provided that, to the extent it is legally permitted to
                            do so, it gives the other party as much notice of such disclosure as possible
                            and, where notice of disclosure is not prohibited and is given in accordance
                            with this clause 11.4, it takes into account the reasonable requests of the
                            other party in relation to the content of such disclosure.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>11.5<span>
                        </span></span></span>
                        <span>The Customer acknowledges that details of the Services, and
                            the results of any performance tests of the Services, constitute the Supplier's
                            Confidential Information.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>11.6<span>
                        </span></span></span>
                        <span>No party shall make, or permit any person to make, any
                            public announcement concerning this Agreement without the prior written consent
                            of the other parties (such consent not to be unreasonably withheld or delayed),
                            except as required by law, any governmental or regulatory authority (including,
                            without limitation, any relevant securities exchange), any court or other
                            authority of competent jurisdiction.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>11.7<span>
                        </span></span></span>
                        <span>The above provisions of this clause 11 shall survive
                            termination of this Agreement, however arising.</span>
                    </p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>12.<span>
                        </span></span></span></b>
                        <b><span>Indemnity</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>12.1<span>
                        </span></span></span>
                        <span>The Customer shall defend, indemnify and hold harmless the
                            Supplier against claims, actions, proceedings, losses, damages, expenses and
                            costs (including without limitation court costs and reasonable legal fees)
                            arising out of or in connection with the Customer's use of the Services.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>12.2<span>
                        </span></span></span>
                        <span>In the defence or settlement of any claim, the Supplier may
                            procure the right for the Customer to continue using the Services, replace or
                            modify the Services so that they become non-infringing or, if such remedies are
                            not reasonably available, terminate this Agreement on 2 Business Days' notice
                            to the Customer without any additional liability or obligation to pay
                            liquidated damages or other additional costs to the Customer.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>12.3<span>
                        </span></span></span>
                        <span>In no event shall the Supplier, its employees, agents and
                            sub-contractors be liable to the Customer to the extent that the alleged
                            infringement is based on:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>a modification of the Services by anyone other than the
                            Supplier; or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>the Customer's use of the
                            Services in a manner contrary to the instructions given to the Customer by the
                            Supplier; or</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(c)<span>
                        </span></span></span>
                        <span>the Customer's use of the Services after notice of the
                            alleged or actual infringement from the Supplier or any appropriate authority.</span>
                    </p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>13.<span>
                        </span></span></span></b>
                        <b><span>Limitation of liability</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>13.1<span>
                        </span></span></span>
                        <span>Except as expressly and specifically provided in this
                            Agreement:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>the Customer assumes sole responsibility for results
                            obtained from the use of the Services by the Customer, and for conclusions
                            drawn from such use. The Supplier shall have no liability for any damage caused
                            by errors or omissions in any information, instructions or scripts provided to
                            the Supplier by the Customer in connection with the Services, or any actions
                            taken by the Supplier at the Customer's direction;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>all warranties, representations,
                            conditions and all other terms of any kind whatsoever implied by statute or
                            common law are, to the fullest extent permitted by applicable law, excluded
                            from this Agreement; and</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(c)<span>
                        </span></span></span>
                        <span>the Services are provided to the Customer on an "as
                            is" basis.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>13.2<span>
                        </span></span></span>
                        <span>Nothing in this Agreement excludes the liability of either
                            Party<a className="text-blue-600 underline"></a> for death or personal injury caused by
                            the Supplier's negligence<a className="text-blue-600 underline"></a> or for fraud or
                            fraudulent misrepresentation.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>13.3<span>
                        </span></span></span>
                        <span>Subject to clause 13.1 and clause 13.2:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>the Supplier shall not be liable whether in tort (including
                            for negligence or breach of statutory duty), contract, misrepresentation,
                            restitution or otherwise for any loss of profits, loss of business, depletion
                            of goodwill and/or similar losses or loss or corruption of data or information,
                            or pure economic loss, or for any special, indirect or consequential loss,
                            costs, damages, charges or expenses however arising under this Agreement; and</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>the Supplier's total aggregate
                            liability in contract, tort (including negligence or breach of statutory duty),
                            misrepresentation, restitution or otherwise, arising in connection with the
                            performance or contemplated performance of this Agreement shall be limited to
                            £1,000 in aggregate.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>13.4<span>
                        </span></span></span>
                        <span>Nothing in this Agreement limits or excludes the liability
                            of the Customer for any breach, infringement or misappropriation of the
                            Supplier’s Intellectual Property Rights.</span>
                    </p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>14.<span>
                        </span></span></span></b>
                        <span>



                        </span><b><span>Term and termination</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>14.1<span>
                        </span></span></span>
                        <span>This Agreement shall be for the Term and shall continue for
                            the Initial Subscription Term and, thereafter, this Agreement shall be
                            automatically renewed monthly (each a <b>Renewal
                                Period</b>) (together <b>Subscription</b> <b>Term</b>)</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>14.2<span>
                        </span></span></span>
                        <span>Without affecting any other right or remedy available to it,
                            either party may terminate this Agreement with immediate effect by giving
                            written notice to the other party if:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>the other party fails to pay any amount due under this
                            Agreement on the due date for payment and remains in default not less than 30
                            days after being notified in writing to make such payment;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>the other party suspends, or
                            threatens to suspend, payment of its debts or is unable to pay its debts as
                            they fall due or admits inability to pay its debts or is deemed unable to pay
                            its debts within the meaning of section 123 of the Insolvency Act 1986 or any
                            other insolvency or administration process commences;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(c)<span>
                        </span></span></span>
                        <span>the other party suspends or ceases, or threatens to suspend
                            or cease, carrying on all or a substantial part of its business;</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(d)<span>       </span></span></span>
                        <span>the other party's financial
                            position deteriorates so far as to reasonably justify the opinion that its
                            ability to give effect to the terms of this Agreement is in jeopardy.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>14.3<span>
                        </span></span></span>
                        <span>On termination of this Agreement for any reason:</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>(a)<span>
                        </span></span></span>
                        <span>all licences granted under this Agreement shall immediately
                            terminate and the Customer shall immediately cease all </span><span>use of the
                                Services; </span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <span><span>(b)<span>       </span></span></span>
                        <span>any rights,
                            remedies, obligations or liabilities of the parties that have accrued up to the
                            date of termination, including the right to claim damages in respect of any
                            breach of the agreement which existed at or before the date of termination
                            shall not be affected or prejudiced.</span>
                    </p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <b><span><span>15.<span>
                        </span></span></span></b>
                        <b><span>General</span></b>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a>
                        <span><span>15.1<span>
                        </span></span></span>
                        <b><span>Force Majeure.</span></b><span> The Supplier shall have no liability to the Customer under
                            this Agreement if it is prevented from or delayed in performing its obligations
                            under this Agreement, or from carrying on its business, by acts, events,
                            omissions or accidents beyond its reasonable control, including, without
                            limitation, strikes, lock-outs or other industrial disputes (whether involving
                            the workforce of the Supplier or any other party), failure of a utility service
                            or transport or telecommunications network, act of God, war, riot, civil
                            commotion, malicious damage, compliance with any law or governmental order,
                            rule, regulation or direction, accident, breakdown of plant or machinery, fire,
                            flood, storm or default of suppliers or sub-contractors, provided that the
                            Customer is notified of such an event and its expected duration.</span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>
                        <span><span>15.2<span>
                        </span></span></span>
                        <b><span>Conflict<a className="text-blue-600 underline"></a>. </span></b><span>If there is an inconsistency between any of the provisions
                            in of this Agreement and the policies, the provisions of this Agreement shall
                            prevail.<a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>

                        </span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>15.3<span>
                        </span></span></span>
                        <b><span>Variation<a className="text-blue-600 underline"></a>. </span></b><span>Except as expressly provided in this Agreement, the Supplier
                            shall be entitled to vary the terms of this<span>
                            </span>Agreement.<a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>

                        </span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>15.4<span>
                        </span></span></span>
                        <b><span>Waiver<a className="text-blue-600 underline"></a>.</span></b><span> No failure or delay by a party
                            to exercise any right or remedy provided under this Agreement or by law shall
                            constitute a waiver of that or any other right or remedy, nor shall it prevent
                            or restrict the further exercise of that or any other right or remedy. No
                            single or partial exercise of such right or remedy shall prevent or restrict
                            the further exercise of that or any other right or remedy.<a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>

                        </span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>15.5<span>
                        </span></span></span>
                        <b><span>Severance<a className="text-blue-600 underline"></a>.</span></b><span> If any provision or part-provision of this Agreement is or
                            becomes invalid, illegal or unenforceable, it shall be deemed deleted, but that
                            shall not affect the validity and enforceability of the rest of this Agreement.<a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>

                        </span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>15.6<span>
                        </span></span></span>
                        <b><span>Entire agreement<a className="text-blue-600 underline"></a>.</span></b><span> This Agreement constitutes the entire agreement between the
                            parties and supersedes and extinguishes all previous agreements, promises,
                            assurances, warranties, representations and understandings between them,
                            whether written or oral, relating to its subject matter.<a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>

                        </span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>15.7<span>
                        </span></span></span>
                        <b><span>Assignment<a className="text-blue-600 underline"></a>.</span></b><span> The Customer shall not, without the prior written consent
                            of the Supplier, assign, transfer, charge, sub-contract or deal in any other
                            manner with all or any of its rights or obligations under this Agreement.<a className="text-blue-600 underline"></a> The Supplier may at any time assign, transfer,
                            charge, sub-contract or deal in any other manner with all or any of its rights
                            or obligations under this Agreement.<a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>

                        </span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>15.8<span>
                        </span></span></span>
                        <b><span>No partnership or agency<a className="text-blue-600 underline"></a>.</span></b><span> Nothing in this Agreement is intended to or shall operate
                            to create a partnership between the parties, or authorise either party to act
                            as agent for the other, and neither party shall have the authority to act in
                            the name or on behalf of or otherwise to bind the other in any way (including,
                            but not limited to, the making of any representation or warranty, the
                            assumption of any obligation or liability and the exercise of any right or
                            power).<a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>

                        </span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>15.9<span>
                        </span></span></span>
                        <b><span>Third party rights<a className="text-blue-600 underline"></a>.</span></b><span> This Agreement does not confer any rights on any person or
                            party (other than the parties to this Agreement and, where applicable, their
                            successors and permitted assigns) pursuant to the Contracts (Rights of Third
                            Parties) Act 1999.<a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>

                        </span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>15.10<span>
                        </span></span></span>
                        <b><span>Notices<a className="text-blue-600 underline"></a>.</span></b><span> Any notice required to be given under this Agreement shall
                            be in writing and shall be delivered by hand or sent by pre-paid first-class
                            post or recorded delivery post to the other party at its address set out in
                            this Agreement, or such other address as may have been notified by that party
                            for such purposes.<a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a><a className="text-blue-600 underline"></a>

                        </span>
                    </p>

                    <p className="text-base mb-2">
                        <span><span>15.11<span>
                        </span></span></span>
                        <b><span>Law and Jurisdiction</span></b><span>

                        </span>
                    </p>

                    <p className="text-base mb-2"><a className="text-blue-600 underline"></a><span>If the Customer is a consumer, this Agreement is governed by English
                        law. The Parties agree that the courts of England and Wales will have exclusive
                        jurisdiction except that if the Customer is a resident of Northern Ireland or
                        Scotland, it may also bring proceedings in Northern Ireland or Scotland
                        respectively.</span></p>

                    <p className="text-base mb-2"><span>If the Customer is a business, these
                        terms of use, their subject matter and their formation (and any non-contractual
                        disputes or claims) are governed by English law. The Parties agree to the
                        exclusive jurisdiction of the courts of England and Wales.</span></p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                    <p className="text-base mb-2"><span>

                    </span></p>

                </div>



            </body></html>
        </div>
    );
};

export default UserAgreement;
